import React from 'react';
// Verify your contact image path
import contactCubes from '../../assets/images/contactusimg.jpg'; 

const SansmrutiContact = () => {
    return (
        <div style={{ padding: '60px 20px', maxWidth: '1200px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
            <h2 style={{ textAlign: 'center', color: '#032167', fontSize: '32px', marginBottom: '40px', fontWeight: 'bold' }}>
                The Global School Of Happiness
            </h2>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '40px', justifyContent: 'center', alignItems: 'flex-start' }}>
                
                {/* Left Side: Image */}
                <div style={{ flex: '1', minWidth: '300px', textAlign: 'center' }}>
                    <img 
                        src={contactCubes} 
                        alt="Contact Us" 
                        style={{ width: '100%', borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }} 
                    />
                </div>

                {/* Middle: Contact Info */}
                <div style={{ flex: '1', minWidth: '250px', padding: '10px' }}>
                    <div style={{ marginBottom: '20px' }}>
                        <p style={{ color: '#032167', fontWeight: 'bold', margin: '0' }}>Whatsapp : +91 8080420434</p>
                    </div>
                    <div>
                        <p style={{ color: '#032167', fontWeight: 'bold', margin: '0' }}>Email : tgsoh91@gmail.com</p>
                    </div>
                </div>

                {/* Right Side: Contact Form */}
                <div style={{ flex: '2', minWidth: '350px' }}>
                    <form style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        <div style={{ display: 'flex', gap: '15px' }}>
                            <input type="text" placeholder="Name" style={inputStyle} />
                            <input type="email" placeholder="Email" style={inputStyle} />
                        </div>
                        <textarea placeholder="Message" rows="5" style={{ ...inputStyle, resize: 'none' }}></textarea>
                        <button type="submit" style={buttonStyle}>
                            SUBMIT
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

// Common Styles
const inputStyle = {
    width: '100%',
    padding: '12px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '16px'
};

const buttonStyle = {
    backgroundColor: '#54a50f',
    color: 'white',
    padding: '12px 30px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold',
    width: 'fit-content'
};

export default SansmrutiContact;